import React, { useState } from 'react';
import axios from 'axios';

import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';

import { Close } from '@mui/icons-material';

import { useDataAuth } from '../../../hooks/useDataAuth';
import { useTranslation } from 'react-i18next';
import { ActionIconItem } from '../../others/ActionIconItem';

export const ShowDocument = ({ data }) => {
    const { t } = useTranslation();
    const [{ userSession }] = useDataAuth();
    const [open, setOpen] = useState(false);
    const [name, setName] = useState('');
    const [pdfBase64, setPdfBase64] = useState(null);

    const DownloadClick = async (param) => {
        setPdfBase64(null);
        let bodyData = param[0]?.bodyData;
        const url = param[0]?.url;
        let nameFile = bodyData.path.split('/').pop();
        setName(nameFile);
        const method = param[0]?.method;

        let config = {
            method: method,
            url: url,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${userSession.token}`
            },
            data: JSON.stringify(bodyData)
        };

        try {
            const response = await axios.request(config);
            if (response.status === 200)
                handleFile(response.data, nameFile)
            else
                console.error('R_ ', response.status);
        } catch (error) {
            console.error(error);
        }
    };

    const MAX_SIZE_MB = 1.8;
    const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024;
    function handleFile(base64String, nameFile) {
        const padding = (base64String.match(/=/g) || []).length;
        const base64Length = base64String.length - padding;
        const fileSizeBytes = (base64Length * 3) / 4;

        if (fileSizeBytes > MAX_SIZE_BYTES)
            downloadFile(base64String, nameFile);
        else {
            renderFile(base64String, nameFile);
        }
    }

    function downloadFile(base64String, nameFile) {
        setOpen(false);

        const extension = nameFile?.split('.').pop()?.toLowerCase();
        let mimeType = 'application/octet-stream';

        if (extension === 'pdf') mimeType = 'application/pdf';
        else if (extension === 'png') mimeType = 'image/png';
        else if (extension === 'jpg' || extension === 'jpeg') mimeType = 'image/jpeg';

        const link = document.createElement('a');
        link.href = `data:${mimeType};base64,${base64String}`;
        link.download = nameFile;
        link.click();
    }

    function downloadFileHref() {
        setOpen(false);
        const link = document.createElement('a');
        link.href = pdfBase64;
        link.download = name;
        link.click();
    }

    function renderFile(base64String, nameFile) {
        console.log('renderFile ', nameFile);
        const extension = nameFile?.split('.').pop()?.toLowerCase();
        let mimeType = 'application/octet-stream';

        if (extension === 'pdf') mimeType = 'application/pdf';
        else if (extension === 'png') mimeType = 'image/png';
        else if (extension === 'jpg' || extension === 'jpeg') mimeType = 'image/jpeg';
        console.log({ extension, mimeType });

        setPdfBase64(`data:${mimeType};base64,${base64String}`);
    }

    return (
        <React.Fragment>
            <ActionIconItem
                item={data}
                onClick={() => {
                    setOpen(true);
                    DownloadClick(data.trigger);
                }}
                defaultIcon="Task"
            />

            <Dialog
                open={open}
                fullScreen
            >
                <DialogTitle>
                    <Typography
                        variant="h5"
                        component="h5"
                        onClick={downloadFileHref}
                        sx={{
                            cursor: 'pointer',
                            color: 'black',
                            textDecoration: 'underline',
                            '&:hover': {
                                color: 'gray',
                            },
                        }}
                    >
                        {t("pdfView")}
                    </Typography>

                    <IconButton
                        aria-label="close"
                        onClick={() => setOpen(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    {
                        pdfBase64 ?
                            <>
                                {name?.toLowerCase().endsWith('.pdf') ?
                                    <iframe
                                        title={t("pdfView")}
                                        className='iframe-size-view-pdf'
                                        src={pdfBase64}
                                    />
                                    :
                                    <div className="container-center-img">
                                        <img
                                            src={pdfBase64}
                                            alt='Base64 content'
                                            className='iframe-size-view-pdf'
                                        />
                                    </div>
                                }
                            </>
                            :
                            <Container
                                sx={{
                                    width: 1250,
                                    height: 450,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <CircularProgress color='primary' />
                                <Typography>{t("loading")}...</Typography>
                            </Container>
                    }
                </DialogContent>
            </Dialog>
        </React.Fragment>
    )
}